var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#E6F1FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6768 14.1387C22.6296 14.1308 22.5745 14.1308 22.5272 14.1387C21.4405 14.0993 20.5742 13.2094 20.5742 12.1069C20.5742 10.9808 21.4798 10.0752 22.606 10.0752C23.7321 10.0752 24.6377 10.9887 24.6377 12.1069C24.6298 13.2094 23.7636 14.0993 22.6768 14.1387Z",
    stroke: "#0070F4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8674 19.8718C22.9463 20.0529 24.1354 19.8639 24.9701 19.3048C26.0805 18.5646 26.0805 17.3518 24.9701 16.6116C24.1275 16.0524 22.9226 15.8634 21.8438 16.0524",
    stroke: "#0070F4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2031 14.1387C13.2503 14.1308 13.3054 14.1308 13.3527 14.1387C14.4394 14.0993 15.3057 13.2094 15.3057 12.1069C15.3057 10.9808 14.4001 10.0752 13.2739 10.0752C12.1478 10.0752 11.2422 10.9887 11.2422 12.1069C11.2501 13.2094 12.1163 14.0993 13.2031 14.1387Z",
    stroke: "#0070F4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0137 19.8718C12.9348 20.0529 11.7457 19.8639 10.9109 19.3048C9.80053 18.5646 9.80053 17.3518 10.9109 16.6116C11.7535 16.0524 12.9584 15.8634 14.0373 16.0524",
    stroke: "#0070F4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9503 20.021C17.903 20.0131 17.8479 20.0131 17.8007 20.021C16.7139 19.9816 15.8477 19.0918 15.8477 17.9893C15.8477 16.8631 16.7533 15.9575 17.8794 15.9575C19.0055 15.9575 19.9112 16.871 19.9112 17.9893C19.9033 19.0918 19.037 19.9895 17.9503 20.021Z",
    stroke: "#0070F4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.657 22.5016C14.5466 23.2418 14.5466 24.4545 15.657 25.1948C16.917 26.0374 18.9802 26.0374 20.2402 25.1948C21.3506 24.4545 21.3506 23.2418 20.2402 22.5016C18.9881 21.6668 16.917 21.6668 15.657 22.5016Z",
    stroke: "#0070F4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.c8799d2e759ced4f6ee8ae08b76d0f96.svg";
export { ForwardRef as ReactComponent };